import { ContactResp } from "../../interfaces/services/Content";
import apiUrls from "../../store/apiUrls";
import apiService from "./apiService";

const contentService = {
  createContact: (contact: FormData): Promise<string> => {
    return apiService.CONTENT.post(apiUrls.content.contact.contact, contact, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  getPagedContact: (page: number): Promise<ContactResp> => {
    return apiService.CONTENT.get(
      `${apiUrls.content.contact.contactPaged}/${page}`
    );
  },
  readContact: (code: string) => {
    return apiService.CONTENT.post(
      `${apiUrls.content.contact.contactRead}/${code}`
    );
  },
};

export default contentService;
